var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84 16.07h12.32c.148 0 .268-.12.268-.268v-1.607a.269.269 0 00-.267-.268H8.839a.269.269 0 00-.268.268v1.607c0 .147.12.268.268.268z",
    fill: "#E1E1E1",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.322 1.607H2.679A1.07 1.07 0 001.607 2.68v24.643a1.07 1.07 0 001.072 1.071h24.643a1.07 1.07 0 001.071-1.071V2.679a1.07 1.07 0 00-1.071-1.072zm-1.34 24.375H4.018V4.018h21.964v21.964z",
    fill: "#E1E1E1",
    stroke: "#fff"
  })));
}
export default SvgDel;